export const DEFAULT_HIDE_DELAY = 3000;
export const DEFAULT_MAX_TOASTS_NUMBER = 3;
export const DEFAULT_MAX_TOASTS_NUMBER_MOBILE = 1;
export const DEFAULT_PLACEMENT_DESKTOP = 'bottom-right';
export const DEFAULT_PLACEMENT_MOBILE = 'bottom-center';
export const hidableToasts = ['success', 'error', 'info'];